module.exports = __webpack_public_path__ + "img/m_role_3_name.0f6426da.png";